import { animate, style, transition } from '@angular/animations';
import { ImproverConstants } from '@improver/app-config';

export const distractionFreeModeToggle = [
  transition(':enter', [
    style({
      position: 'absolute',
      top: 0,
      right: 0,
      opacity: 0,
      transform: 'translateY(-100%)',
    }),
    animate(
      ImproverConstants.ANIMATION_MEDIUM_TIMING,
      style({
        opacity: 1,
        transform: 'translateY(0)',
      })
    ),
  ]),
  transition(':leave', [
    style({
      position: 'absolute',
      top: 0,
      right: 0,
      opacity: 1,
      transform: 'translateY(0)',
    }),
    animate(
      ImproverConstants.ANIMATION_MEDIUM_TIMING,
      style({
        opacity: 0,
        transform: 'translateY(-100%)',
      })
    ),
  ]),
];
